<template>
  <div class="list">
    <div class="list__main">
      <div class="list__grid list__grid--generic-items" v-click-outside="clearActiveGoal">
        <div class="col" v-for="(col, x) in goals" :key="x">
          <Goal v-for="goal in col" :data="goal" :active="goal.id === activeGoal" :index="goal.id" :key="goal.id"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Fallback from '../common/Fallback';
  import ClickOutside from 'vue-click-outside';
  import { EventBus } from '../../eventbus';
  import Goal from '../common/Goal';

  export default {
    name: 'ListGoals',

    props: {
      goals: Array,
    },

    components: {
      Goal,
    },

    directives: {
      ClickOutside
    },

    data: () => {
      return {
        activeGoal: null,
        fallBack: Fallback,
      }
    },

    mounted: function () {
      EventBus.$on('active-goal', async (data) => {
        this.activeGoal = data === this.activeGoal ? null : data;
      });
    },

    methods: {
      clearActiveGoal: function () {
        this.activeGoal = null;
      },
    }
  }
</script>
